import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { formRender, initialValues, customerValidations } from "./customer-schema";
import CustomerInfo from "./components/CustomerInfo";
import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { createCustomer, getCarrierList } from "services/data.internal.service";
import { Success, Error_ } from "ui-components/Alert";
import { useNavigate } from "react-router-dom";

function AddCustomer() {
  const [alert, setAlert] = useState(null);
  const [carrierCodeOptions, setCarrierCodeOptions] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const createCustomerMutation = useMutation(createCustomer, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  useQuery({
    queryKey: ["carrier-options"],
    queryFn: () => getCarrierList({ active: true }),
    onSuccess: (data) => setCarrierCodeOptions(data.data.data.map((x) => x.carrierCode)),
    onError,
  });
  const form = useForm({
    defaultValues: { ...initialValues, currencyCode: "MYR", customerType: "Principle" },
    resolver: yupResolver(customerValidations),
  });

  const navigate = useNavigate();

  const {
    register,
    getValues,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    register,
    getValues,
    control,
    errors,
    setValue,
    formRender,
    carrierCodeOptions,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    createCustomerMutation.mutate(data, {
      onSuccess: () =>
        navigate("/setup/customer/wh-setting/add", { state: { customerCode: data.customerCode, apiSecretKey: data.apiSecretKey } }),
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CustomerInfo {...infoProps} />
        <SubmitButton label="submit" disabled={isSubmitting} url="/setup/customer" />
      </form>
    </Layout>
  );
}

export default AddCustomer;
